<template>
    <div class="editor">
        <div class="editor-menu">
            <div :class="{'editor-menu-selected' : menuIndex == 0}" @click="changeMenu(0)">需求信息</div><div :class="{'editor-menu-selected' : menuIndex == 1}" @click="changeMenu(1)">服务信息</div>
        </div>
        <div class="editor-list" v-if="menuIndex == 0">
            <div class="editor-list-li" v-for="(item, i) in demandList" :key="i">
                <div class="editor-check">
                    <a-checkbox @change="onChangeByDemand" v-model:value="item.id"/>
                </div>
                <div class="editor-info" @click="clickInfo('需求信息',item.id)">
                    <div class="editor-img"><img :src="internalInstance.appContext.config.globalProperties.$imgUrl + item.imgs" alt=""></div>
                    <div class="editor-title">{{ item.title }}</div>
<!--                    <a class="editor-a" @click="handleChange('demand', item.id)">修改信息</a>-->
                </div>
            </div>
            <div class="editor-fixed" v-show="demandSize > 0">
                <div class="editor-check">已选{{ demandSize }}条</div>
                <div class="delete-btn" @click="handleDelete('demand')">删除需求</div>
            </div>
        </div>
        <div class="editor-list" v-else-if="menuIndex == 1">
            <div class="editor-list-li" v-for="(item, i) in serviceList" :key="i">
                <div class="editor-check">
                    <a-checkbox @change="onChangeByService" v-model:value="item.id"/>
                </div>
                <div class="editor-info" @click="clickInfo('服务信息',item.id)">
                    <div class="editor-img"><img :src="internalInstance.appContext.config.globalProperties.$imgUrl + item.imgs" alt=""></div>
                    <div class="editor-title">{{ item.title }}</div>
<!--                    <a class="editor-a" @click="handleChange('service', item.id)">修改信息</a>-->
                </div>
            </div>
            <div class="editor-fixed" v-show="serviceSize > 0">
                <div class="editor-check">已选{{ serviceSize }}条</div>
                <div class="delete-btn" @click="handleDelete('service')">删除服务</div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import { ref, getCurrentInstance } from 'vue'
import { getDemandList, deleteDemand } from "@/api/demand"
import { getServiceList, deleteService } from '@/api/service'
import {notification} from "ant-design-vue"
import { useRouter } from "vue-router"
export default {
    name: "EditInformation",
    setup() {
        const userInfo = Cookies.get('userInfo')
        const demandList = ref([])
        const serviceList = ref([])
        const internalInstance = getCurrentInstance()
        const demandDeleteList = ref([])
        const serviceDeleteList = ref([])
        const demandSize = ref(0)
        const serviceSize = ref(0)
        const menuIndex = ref(0)
        const router = useRouter()
        return {
            checked: ref(false),
            userInfo,
            demandList,
            serviceList,
            internalInstance,
            demandDeleteList,
            serviceDeleteList,
            demandSize,
            serviceSize,
            menuIndex,
            router
        }
    },
    mounted() {
        this.initDemandList()
    },
    methods: {
        clickInfo(title, id) {
            this.router.push({ name: 'ALSDetails', query: {name: title, id: id}})
        },
        changeMenu(index) {
            this.menuIndex = index
            if (index == 0) {
                this.initDemandList()
                this.demandDeleteList = []
                this.demandSize = 0
            } else if (index == 1) {
                this.initServiceList()
                this.serviceDeleteList = []
                this.serviceSize = 0
            }
        },
        async initDemandList() {
            if (this.demandList.length == 0) {
                if (this.userInfo) {
                    const userId = JSON.parse(this.userInfo).userId
                    const params = {
                        "current": 1,
                        "model": {
                            createdBy: userId
                        },
                        "size": 2000,
                    }
                    const data = await getDemandList(params)
                    this.demandList = data.records
                }
            }
        },
        async initServiceList() {
            if (this.serviceList.length == 0) {
                if (this.userInfo) {
                    const userId = JSON.parse(this.userInfo).userId
                    const params = {
                        "current": 1,
                        "model": {
                            createdBy: userId
                        },
                        "size": 2000,
                    }
                    const data = await getServiceList(params)
                    this.serviceList = data.records
                }
            }
        },
        handleChange(type, id) {
            console.log(type, id)
        },
        onChangeByDemand(e) {
            if (this.demandDeleteList.indexOf(e.target.value) == -1) {
                this.demandDeleteList.push(e.target.value)
            } else {
                // 删除
                this.demandDeleteList.splice(this.demandDeleteList.indexOf(e.target.value))
            }
            this.demandSize = this.demandDeleteList.length
        },
        onChangeByService(e) {
            if (this.serviceDeleteList.indexOf(e.target.value) == -1) {
                this.serviceDeleteList.push(e.target.value)
            } else {
                // 删除
                this.serviceDeleteList.splice(this.serviceDeleteList.indexOf(e.target.value))
            }
            this.serviceSize = this.serviceDeleteList.length
        },
        async handleDelete(type) {
            if (type == 'demand') {
                const res = await deleteDemand(this.demandDeleteList.toString())
                if (res) {
                    notification.success({ message: '删除成功！', duration: 2, description: '' })
                    this.demandDeleteList = []
                    window.location.reload()
                }
            } else if (type == 'service') {
                const res = await deleteService(this.serviceDeleteList.toString())
                if (res) {
                    notification.success({ message: '删除成功！', duration: 2, description: '' })
                    this.serviceDeleteList = []
                    window.location.reload()
                }
            }
        }
    }
}
</script>

<style scoped lang="stylus">
    .editor {
        width 100%
        height 100%
        overflow-y auto
        .editor-menu {
            width 100%
            height 40px
            line-height 40px
            text-align center
            display flex
            color rgba(34, 34, 34, 1)
            font-size 16px
            box-shadow 0 3px 6px rgba(0, 0, 0, 0.16)
            .editor-menu-selected {
                color #F3F3F3
                background #76C274
            }
        }
        .editor-menu div {
            width 50%
        }
        .editor-list {
            width 100%
            background #F6F6F6
            position relative
            margin-bottom 55px
            padding 10px 0
            .editor-list-li {
                width 100%
                height 75px
                margin-bottom 8px
                box-shadow 0 3px 6px rgba(0, 0, 0, 0.07)
                background #FFF
                padding 0 10px
                display flex
                justify-content space-between
                .editor-check {
                    width 20px
                    height 100%
                    line-height 75px
                }
                .editor-info {
                    width calc(100% - 20px)
                    height 100%
                    position relative
                    .editor-img {
                        width 75px
                        height 100%
                        overflow hidden
                    }
                    .editor-img img {
                        width 100%
                        height 100%
                    }
                    .editor-title {
                        position absolute
                        top 0
                        left 85px
                        font-size 16px
                        color #222222
                        height 50px
                        overflow hidden
                    }
                    .editor-a {
                        position absolute
                        right 10px
                        bottom 0
                        font-size 16px
                    }
                }
            }
            .editor-fixed {
                width 100%
                height 55px
                background #FFF
                position fixed
                bottom 0
                left 0
                display flex
                justify-content space-between
                .editor-check {
                    height 55px
                    line-height 55px
                    padding-left 20px
                }
                .delete-btn {
                    width 110px
                    height 55px
                    line-height 55px
                    text-align center
                    color #FFF
                    font-size 16px
                    background #76C274
                    cursor pointer
                }
            }
        }
    }
</style>